import React from 'react'
export default class Component extends React.Component {
  render = () => {
    return (
      <div className='static-page-wrap text-left small'>
        <p>株式会社circrew（以下、「当社」といいます）は、個人情報が個人の重要な財産であることを認識し、個人情報を適切に取得・利用し、個人情報に関する法令等を遵守し、個人情報の漏えい等を防止・是正するため、以下のとおり個人情報の取扱方針を定め、最新の注意を払って管理運用します。<br />
        なお、リンク先など他事業者等による個人情報収集は、当プライバシーポリシーの適用範囲ではございませんのでご留意下さい。</p>
        <h3>第１条（適切な取得と利用目的）</h3>
        <p>当社は適法な手段により、以下の利用目的のため、個人情報を取得します。</p>
        <ul>
          <li>・当社サービスの提供のため</li>
          <li>・現在提供している当社サービス又は今後提供を検討している当社サービスの案内及びアンケート実施のため</li>
          <li>・メールマガジン配信のため</li>
          <li>・サービスの改善や新サービスの開発等に役立てるため</li>
          <li>・ご本人への連絡のため</li>
          <li>・ご本人からのお問い合わせの際の本人確認その他の対応のため</li>
          <li>・キャンペーン等の抽選及び賞品や商品発送のため</li>
          <li>・当社又は当社以外の第三者が広告主となる広告情報等の配信のため</li>
          <li>・当社サービスの利用に関する統計データの作成のため</li>
          <li>・利用規約に違反する態様でのご利用を防止するため</li>　
        </ul>
        <h3>第２条（適正な管理と保護）</h3>
        <p>個人情報の管理は、厳重に行うこととし、個人情報に関する不正アクセス、紛失、破壊、改ざん、漏洩を防ぐための適切な予防及び是正処置を行います。</p>        
        <h3>第３条（預託）</h3>
        <p>当社は利用目的の達成に必要な範囲内において、取得した個人情報の全部又は一部を業務委託先に預託することがあります。その際、業務委託先としての適格性を十分審査するとともに、契約にあたって守秘義務に関する事項等を規定し、業務委託先に対し必要かつ適切な監督を行います。</p>
        <h3>第４条（第三者提供）</h3>
        <p>当社は、以下の場合を除き、第三者に対しデータを開示・提供することはいたしません。</p>
        <ul>
          <li>・ご本人が事前に同意した場合</li>
          <li>・法令に基づく場合</li>
          <li>・当社サービスの利用規約の違反があり、当社の権利、財産やサービスなどを保護するために、個人情報を公開せざるをえないと判断するに足る十分な根拠がある場合</li>
          <li>・人の生命、身体又は財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難である場合</li>
          <li>・公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難である場合</li>
          <li>・国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合</li>
          <li>・合併、会社分割、営業譲渡その他の事由によって個人情報の提供を含む当社の事業の承継が行われる場合</li>
        </ul>
        <h3>第５条（共同利用）</h3>
        <p>当社は、当社サービスの提供にあたり、当社の業務提携先と個人情報を共同利用することがあります。この場合に当社は、共同利用に先立ち、共同して利用する個人情報の項目、共同利用者の範囲、共同利用する個人情報の利用目的、共同利用する個人情報の管理責任者の氏名又は名称についてあらかじめ公表いたします。</p>
        <h3>第６条（１８歳未満の未成年者の利用について）</h3>
        <p>１８歳未満の方が当社サービスを利用し、個人情報を入力される場合には保護者の方の同意のもとに行っていただけますようお願いいたします。</p>
        <h3>第７条（開示等の手続）</h3>
        <p>当社は、ご本人からの（ご自身の）個人情報の利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者提供の停止（以下「開示等」といいます）のお申し出に対して、遅滞なく応じます。<br />
        なお、開示等の請求は当社所定の手続きにて行っていただく必要がございます。</p>
        <h3>第８条（免責）</h3>
        <p>当社は、ご本人が当社サービスの機能その他手段を用いて第三者に個人情報を明らかにした場合、ご本人が当社サービス上にて開示した情報等により個人を識別できてしまった場合には、何ら責任を負わないものとします。</p>
        <h3>第９条（統計データの作成及び利用）</h3>
        <p>当社は、取得した個人情報をもとに個人を識別できないように加工した統計データを作成することがあります。個人を識別できないように加工した統計データの作成・利用につきましては、当社は何らの制限なく行うことができるものとします。</p>
        <h3>第１０条（属性情報・行動履歴等の取得・利用）</h3>
        <p>当社は、当社サービスや広告の内容をよりご本人に適したものとするために、以下を例とする個人を識別できない情報の取得・利用を行うことがあります。また、同様の目的で広告主や情報提供元、サービス提供元などにかかる情報を提供する場合があります。</p>
        <p>記<br />
        クッキー、ログ、アクセスしたＵＲＬ、コンテンツ、参照順などの行動履歴、端末の個体識別情報などの機器情報、ご本人の性別、職業、年齢などの属性情報<br />
        以上</p>
        <h3>第１１条（改定）</h3>
        <p>当社は、当プライバシーポリシーの全部又は一部を改定することがあります。重要な変更がある場合には、改定内容を当社ウェブサイト上で告知いたします。</p>
        <h3>第１２条（法令、規範の遵守と見直し）</h3>
        <p>当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本個人情報保護方針の内容を適宜見直し、その改善に努めます。</p>
        <h3>第１３条（問い合わせ先）</h3>
        <p>当社は、本人からの個人情報の取扱いに関する問い合わせに対し、適切な対応を努めます。当社の個人情報の取扱いに関するお問い合わせは、下記にご連絡ください。</p>
        <p>〒150-0011<br />
        東京都渋谷区東1-2-20　渋谷ファーストタワー　株式会社circrew<br />
        個人情報保護管理者：個人情報保護管理宛<br />
        苦情相談窓口責任者：個人情報保護苦情相談口責任者宛<br />
        TEL:090-8686-8975 （受付時間：月曜～日曜日 10:00～17:00（年末年始除く））<br />
        Mail: info@circrew.co.jp（「個人情報相談」とタイトルにお書きください。）</p>
        <p>2018年7月18日制定<br />
        株式会社当社<br />
        代表取締役社長　遠藤ちひろ</p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/StaticPages/PrivacyPolicy/Policybody.jsx